import '../../sass/auth.scss';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from '@core/reducers/configureStore';
import UserReducer from '@core/reducers/UserReducer';
import SiteReducer from '@core/reducers/SiteReducer';
import ModalReducer from '@core/reducers/ModalReducer';
import AuthOptionsReducer from '@core/reducers/AuthOptionsReducer';
import { SITE_SET_DATA } from '@core/actions/SiteActions';

import AuthPanel from './components/AuthPanel';

const store = configureStore({
    user: UserReducer,
    site: SiteReducer,
    modal: ModalReducer,
    authOptions: AuthOptionsReducer,
});

const root = document.getElementById('bidding-auth-root');

if (root) {
    const { dataset } = root;
    const redirectTo = dataset.redirect || null;

    store.dispatch({
        type: SITE_SET_DATA,
        payload: {
            googleAppId: dataset.googleAppId || '',
            socialAuthStatusGoogle: parseInt(dataset.socialAuthStatusGoogle, 10) === 1,
            signUpEnabled: parseInt(dataset.signUpEnabled, 10) !== 0,
        },
    });

    render(
        <Provider store={store}>
            <AuthPanel redirectTo={redirectTo} />
        </Provider>,
        root,
    );
}
